import { ToastContainerProps } from 'react-toastify';
import ErrorIcon from '@/assets/icons/alert.svg';
import SuccessIcon from '@/assets/icons/success.svg';

const toastConfigs: ToastContainerProps = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    icon(props) {
        if (props.type === 'error') {
            return <img src={ErrorIcon} alt="Error icon" />;
        } else if(props.type === 'success') {
            return <img src={SuccessIcon} alt="Success icon" />
        }
        return undefined;
    },
    bodyClassName(context) {
        if (context?.type === 'error') {
            return (context?.defaultClassName || '') + 'alert flex items-center !px-0';
        } else if (context?.type === 'success') {
            return (context?.defaultClassName || '') + 'success flex items-center !px-0';
        }
        return context?.defaultClassName || '';
    },
    toastClassName(context) {
        if (context?.type === 'error') {
            return context?.defaultClassName || '';
        } else if (context?.type === 'success') {
            return context?.defaultClassName || '';
        }
        return context?.defaultClassName || '';
    },
};
export default toastConfigs;
